import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";

@Component({
  selector: "modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.css"],
})
export class ModalComponent {

  @ViewChild("smModal") public modal;
  @Output() public formSubmit = new EventEmitter();
  @Input() public headerText: string;
  @Input() public showClose: boolean;
  @Input() public xLarge: boolean;
  @Input() public large: boolean;
  @Input() public medium: boolean;
  @Input() public publish: boolean;
  @Output() public onClose = new EventEmitter();
  @Output() public onHidden = new EventEmitter();

  @Input()
  set show(value) {
    if (this.modal) {
      if (!this.modal.config) {
        this.modal.config = {backdrop: true};
      }
      if (value) {
        this.modal.show();
      } else {
        this.modal.hide();
      }
    }
  }

  public getSizeClass() {
    if (this.large) {
      return "modal-lg";
    }
    if (this.medium) {
      return "modal-md";
    }
    if (this.xLarge) {
      return "modal-xl";
    }
    return "modal-sm";
  }

  public getHeaderSizeClass(type) {
    if (this.large || this.medium || this.xLarge) {
      if ( type === "title" ) {
        return "col-11";
      } else {
        return "col-1";
      }
    } else {
      if ( type === "title" ) {
        return "col-10";
      } else {
        return "col-2";
      }
    }
  }

  public close() {
    this.onClose.emit();
  }

  public cancel() {
    this.formSubmit.emit({
      save: false, cancel: true,
    });
  }

}
